/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2019-08-21 16:14:26
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-05-11 18:48:58
 */
import qs from 'qs'

// axios采用表单方式提交
export const formData = {
  headers: {'Content-Type': 'application/json'},
  transformRequest: [data => {
    return JSON.stringify(data)
  }]
}
export const hostManage = {
  // 开发环境
  // mobile: "https://api-dev.999time.cn", // 移动h5,
  // 测试环境
  mobile: "https://api-test.999time.cn",// 移动h5
  // // 压测环境
  // mobile: "https://api-test85.999time.cn", 
  // 生产环境
  // mobile: "https://h5.xdqtech.com", // 移动h5
  //生产环境2
  //  mobile: "https://mobile.xdqtech.com", // 移动h5
}

// 接口公共参数
export const commonParams = {
  // version: '1.0.0', // 版本号
  // channel: '100001', // 渠道
  // terminal: 'PC', // 终端
  // transNumber: uuid(32, 16) // 交易编号
}

// api接口名和接口地址映射
export const apiData = {
  // loginReq: {url: 'haha/login', method: 'post', prefix: 'noPrefix'}, // 本地登陆
  // logOut: {url: 'haha/loginOut', method: 'post', prefix: 'noPrefix'}, // 本地登陆
  // baseUserInfo: {url: 'haha/baseUserInfo', method: 'post', prefix: 'noPrefix'}, // 本地基础信息
  // 登录
  logIn: {url: 'login', prefix: 'pro'},
  logOut: 'loginOut',
  //基础用户信息
  baseUserInfo: {url: 'baseUserInfo', isCheckRequest: false},

  organJsonListAll: 'sysOrg/querySysUserOrgRel', // 权限--所属组织查询
  organJsonList: 'sysOrg/queryAllSysOrg', //权限--所属组织查询 --不带分页的
  organJsonListPage: 'sysOrg/querySysOrg',  //权限--组织查询
  organJsonCreate: 'sysOrg/createSysOrg',  //权限--组织新增
  organJsonUpdata: 'sysOrg/updateSysOrg',  //权限--组织修改
  organJsonSetrole: 'sysOrg/resetOrgRoleRel',  //权限--设置角色
  organUseJsonLookrole: 'sysOrg/querySysOrgRole', //权限--组织已拥有角色查看
  organJsonListTree: 'sysOrg/initOrgTree',  //权限--组织树查询 --岗位

  roleJsonListAll: 'sysRole/queryAllSysRole',  //权限--角色列表查询-all
  roleJsonList: 'sysRole/querySysRole',  //权限--角色列表查询
  roleJsonCreate: 'sysRole/createSysRole',  //权限--角色列表新增
  roleJsonEdit: 'sysRole/updateSysRole',  //权限--角色列表编辑
  roleJsonModule: 'sysRole/resetRoleModule',  //权限--角色--模块
  roleUseJsonModule: 'sysRole/querySysRoleModule',  //权限--角色拥有--模块
  treeJsonModule: 'sysModule/initModuleTree',  // 权限--模块tree

  moduleJsonCreate: 'sysModule/createSysModule',  //权限--模块新增
  moduleJsonEdit: 'sysModule/updateSysModule',  //权限--模块编辑

  importFloorInfo: 'floor/importFloorInfo',  // 楼层信息导入
  userJsonList: 'sysUser/querySysUser',  //权限--用户列表查询
  userJsonCreate: 'sysUser/createSysUser',  //权限--用户列表新增
  userJsonEdit: 'sysUser/updateSysUser',  //权限--用户列表编辑
  userJsonRemove: 'sysUser/deleteSysUser',  //权限--用户删除
  usedJsonOrgan: 'sysUser/resetUserOrg',  //权限--用户--组织

  noticeList: 'notice/config/manager/query', //公告列表
  noticeCreate: 'notice/config/manager/create', //公告发布
  noticeUpdata: 'notice/config/manager/update', //公告发布修改
  noticeTop: 'notice/config/manager/top', //公告置顶
  noticeDelete: 'notice/config/manager/delete', //公告删除

  queryUnderRegionOrg: 'sysOrg/queryUnderRegionOrg',//查询下级地域机构列表


  columnsList: 'columns/config/manager/query',  //栏目列表
  updatedColumns: 'columns/config/manager/update',//更新栏目列表
  deleteColumns: 'columns/config/manager/delete',//删除栏目
  createColumns: 'columns/config/manager/create',//添加栏目
  columnsContentList: 'columns/content/config/manager/query', //栏目内容列表
  columnsContentCreate: 'columns/content/config/manager/create', //添加栏目内容
  columnsContentDelete: 'columns/content/config/manager/delete',//删除栏目内容
  columnsContentUpdated: 'columns/content/config/manager/update',//更新栏目内容
  columnsContentPush: 'columns/content/config/manager/publish', //发布栏目内容
  getColumnsContentDetail: 'columns/content/config/manager/find', //栏目内容详情
  areaList: 'columns/config/manager/getColumnRegionLevel',//级别查询
  getcitysList: 'region/getRegionByLevel', //根据level查询
  columnsByName: 'columns/config/manager/queryByName', //根据名字查询

  lawsList: 'regulation/config/manager/query', //法律法规列表
  lawsDetail: 'regulation/config/manager/find', //法律法规详情
  lawsDelete: 'regulation/config/manager/delete',//法律法规删除
  lawsUpdate: 'regulation/config/manager/update', //法律法规修改
  lawsCreate: 'regulation/config/manager/create', //法律法规新增
  lawsTop: 'regulation/config/manager/top', //法律法规置顶
  cityList: {url: 'region/getCountriesList', isCheckRequest: false}, //国家列表
  proviceList: 'region/getSubRegionsList', //省列表

  bannerList: 'banner/config/manager/query', //图片列表
  bannerCreate: 'banner/config/manager/create', //图片新增
  bannerUpdata: 'banner/config/manager/update', //图片修改
  bannerTop: 'banner/config/manager/top', //图片置顶
  bannerDelete: 'banner/config/manager/delete', //图片删除

  imageDownload: 'image/manager/download', //图片down
  sideBar: {url: 'ssm/pbmtq', prefix: 'ssmidm', headers: {apptag: 'pro', terminal: 'pc'}}, // 侧边栏
  importModule: 'sysModule/importModule', //模块上传
  deleteSysModule: 'sysModule/deleteSysModule', //模块删除
  deleteSysOrg: 'sysOrg/deleteSysOrg', //组织删除
  deleteSysRole: 'sysRole/deleteSysRole', //角色删除
  deleteSysUser: 'sysUser/deleteSysUser', //用户删除

  querySysOrgDetail: 'sysOrg/querySysOrgDetail', //组织详情查询
  queryOrgHave: 'sysOrg/haveSysOrg', // 查询已有组织列表
  resetOrg: 'sysOrg/resetSysOrg', // 组织的添加和删除
  setOrgVisibility: 'sysOrg/setOrgVisibility', // 设置挂在组织可见性

  querySysJobDetail: 'sysPost/queryOrgPostDetail', // 岗位详情查询
  jobCreate: 'sysPost/createSysPost', // 岗位创建
  jobReset: 'sysPost/resetPostModule', // 配置岗位模块
  jobUpdate: 'sysPost/updateSysPost', // 岗位更新
  getJobModule: 'sysPost/getPostModule', // 岗位的已有模块
  jobDel: 'sysPost/deleteSysPost', // 岗位删除

  organUserList: 'orgUser/queryOrgUser', // 查询机构用户
  organUserCreate: 'orgUser/createOrgUser', // 机构用户信息创建
  organUserReseat: 'orgUser/resetOrgUserPost', // 重置机构用户岗位
  organUserUpdate: 'orgUser/updateOrgUser', // 更新机构用户岗位
  organUser: 'orgUser/getOrgUserPost', // 机构用户岗位查询
  organRoleReseat: 'orgUser/resetOrgUserRole', // 重置机构用户角色
  organRoleList: 'orgUser/getOrgUserRole', // 查询机构角色
  orgTopFromAccount: 'sysOrg/queryUserTopOrgList', // 根据用户账号查找顶层组织
  deleteSysOrgUser: 'orgUser/deleteSysOrgUser',// 删除机构用户

  sysModuleList: 'sysModule/querySysModule', // 系统模块列表查询
  sysModuleCre: 'sysModule/createSysModule', // 系统模块创建
  sysModuleDel: 'sysModule/deleteSysModule', // 系统模块删除
  sysModuleTree: 'sysModule/queryModuleDetail', // 模块树详情查看

  querySysRegion: 'district/querySysRegion', // 地域列表信息查询
  querySysRegionDetails: 'district/querySysRegionDetails', // 地域信息详情查询
  activeOrg: 'orgDetails/activeOrg', // 机构激活

  docTemplateList: 'docTemplate/page', // 文本模板分页查询
  docTemplateDetail: 'docTemplate/detail', // 文本模板明细查询
  docTemplateAdd: 'docTemplate/add', // 新增文本模板
  docTemplateUpdate: 'docTemplate/update', // 修改文本模板
  docTemplateDel: 'docTemplate/delete', // 修改文本模板
  docIdentityList: 'docIdentitylink/list', // 文本模板授权列表查询
  docIdentityDetail: 'docIdentitylink/detail', // 文本模板授权明细查询
  docIdentityUpdate: 'docIdentitylink/update', // 修改文本模板授权信息
  docIdentityAdd: 'docIdentitylink/add', // 新增文本模板授权信息
  docIdentityDel: 'docIdentitylink/delete', // 删除文本模板授权信息

  systemQuery: {url: 'versionUpd/query'}, // 系统升级管理查询
  systemDel: {url: 'versionUpd/delete'}, // 系统升级管理删除
  systemUpdate: {url: 'versionUpd/update'}, // 系统升级管理编辑
  systemAdd: {url: 'versionUpd/insert'}, // 系统升级管理添加
  // 数据字典
  sysDictQuery: 'sysDict/query', // 数据字典列表
  sysDictInsert: 'sysDict/insert', // 新增数据字典
  sysDictUpdate: 'sysDict/update', // 修改字典列表
  sysDictDelete: 'sysDict/delete', // 删除数据字典
  sysDictQueryItem: 'sysDict/queryItem', // 数据字典列表项
  sysDictInsertItem: 'sysDict/insertItem', // 新增数据字典项
  sysDictUpdateItem: 'sysDict/updateItem', // 修改字典列表项
  sysDictDeleteItem: 'sysDict/deleteItem', // 删除数据字典项
  // 系统参数
  sysParamQuery: 'sysParam/query', // 数据系统参数
  sysParamInsert: 'sysParam/insert', // 新增系统参数
  sysParamUpdate: 'sysParam/update', // 修改系统参数
  sysParamDelete: 'sysParam/delete', // 删除系统参数
  // 缓存
  sysCacheQuery: 'sysCache/query', // 缓存查询
  sysCacheRefresh: {url: 'cache/manager/refresh', prefix: 'baseService'}, // 刷新按钮
  // 角色
  resetPostRole: {url: 'sysPost/resetPostRole'}, // 重置角色
  getPostRole: {url: 'sysPost/getPostRole'}, // 角色列表
  outImageSave: {url: 'fileConvert/imageConvert', prefix: 'protos', isCheckRequest: false},
  // 网格管理
  gridManage: 'grid/queryPage',//网格列表查询
  getGridTree: 'grid/gridDetail',//网格树列表
  createGrid: 'grid/createGrid',//网格创建
  deleteGrid: 'grid/deleteGrid',//网格删除
  updateGrid: 'grid/updateGrid',//更新



  // 字典管理
  // organJsonTypeAll:{url:'tag/dict/10800201', method: 'get'}, // 00-物业,01-业主,02-业委会
  // organJsonTypeSub:{url:'tag/dict/10800204', method: 'get'}, // B-分支,J-岗位,F-楼层
  // organJsonTypeVirtual:{url:'tag/dict/10800205', method: 'get'}, // 11-社区,12-街道
  // organJsonTypeShow:{url:'tag/dict/10800206', method: 'get'}, // 展示使用，无须判断条件
  // moduleOperateType:{url:'tag/dict/10800302', method: 'get'}, //模块操作类型获取
  orgTypeList: {url: 'dict/query', data: {dictCode: '10800601'}, method: 'get', prefix: 'baseService'}, // 组织类型查询 【10-小区,11-社区,12-街道】
  orgSubTypeList: {url: 'dict/query', data: {dictCode: '10800602'}, method: 'get', prefix: 'baseService'}, // 组织子类型查询 【D-部门,F-楼层楼宇结构,N-默认】
  positionType: {url: 'dict/query', data: {dictCode: '10800502'}, method: 'get', prefix: 'baseService'}, //轮播图位置获取 【01-首页顶部,02-首页中部,03-我的顶部】
  visitedScopeType: {url: 'dict/query', data: {dictCode: '10800404'}, method: 'get', prefix: 'baseService'}, //可见范围获取【01-所有人员,02-小区人员,03-小区业主】
  // visitedRange:{url:'dict/query', data:{dictCode: 'visiblePalce'}, method: 'get', prefix: 'baseService'},//可见区域获取
  visitedScopeTypeTwo: {url: 'dict/query', data: {dictCode: '10800504'}, method: 'get', prefix: 'baseService'}, //可见范围获取-swiper 【01-所有人员,02-小区人员,03-小区业主】
  publishStatus: {url: 'dict/query', data: {dictCode: '10800501'}, method: 'get', prefix: 'baseService'}, //上架状态获取 【01-上架,02-下架】
  advertiseType: {url: 'dict/query', data: {dictCode: '10800405'}, method: 'get', prefix: 'baseService'}, //公告类型获取
  moduleJsonType: {url: 'dict/query', data: {dictCode: '10800301'}, method: 'get', prefix: 'baseService'},  //权限--模块类型获取 【module-模块,menu-菜单,page-页面,operation-操作】
  moduleSubJsonType: {url: 'dict/query', data: {dictCode: '10800302'}, method: 'get', prefix: 'baseService'},  //权限--模块类型获取 【add-新增,del-删除,mod-修改,list-列表,detail-详情,imp-导入,exp-导出,status-状态】
  userIdJsonType: {url: 'dict/query', data: {dictCode: '10800202'}, method: 'get', prefix: 'baseService'},  //权限--证件类型获取 【1-身份证】
  userSexyJsonType: {url: 'dict/query', data: {dictCode: '10800203'}, method: 'get', prefix: 'baseService'},  //权限--性别获取 【1-男,2-女,N-保密】
  moduleTypeList: {url: 'dict/query', data: {dictCode: '10800303'}, method: 'get', prefix: 'baseService'},  //  模块分类  【00-应用,01-菜单】
  orgTagList: {url: 'dict/query', data: {dictCode: '10800603'}, method: 'get', prefix: 'baseService'}, // 组织标识查询 【other-其他】

  //图片上传
  imageUpdata: {url: 'file/manager/imageUpload', method: 'post', prefix: 'baseService'},

  //三方授权相关
  queryThirdPartyList: {url: 'authorize/queryThirdPartyList'}, //三方授权列表
  thirdAuthedCommunityList: {url: 'authorize/queryCommunityList'},//小区授权列表
  createAuthorizeCommunity: {url: 'authorize/createAuthorizeCommunity'},//小区授权创建
  updateAuthorizeCommunity: {url: 'authorize/updateAuthorizeCommunity'},//小区授权更新
  relieveAuthorizeCommunity: {url: 'authorize/relieveAuthorizeCommunity'},//小区授权解除
  deleteAuthorizeCommunity: {url: 'authorize/deleteAuthorizeCommunity'},//小区授权删除
  queryCommunityListByName: {url: 'authorize/queryCommunityListByName'},//根据小区名称搜索小区列表
  queryCommunityDetails: {url: 'authorize/queryCommunityDetails'},//小区授权详情
  //字典获取
  dictQuery: {url: "dict/query", method: 'get', prefix: 'baseService'},

  //物业业委会同步
  syncOrgs: 'sysOrg/syncOrgs', //同步整个小区至中间库
  receiveOrgs: 'sysOrg/receiveOrgs', //从中间库同步整个小区
  queryOrgsFromRepository: 'sysOrg/queryOrgsFromRepository', //查询中间库小区

  //机构参数配置
  queryCfOrgConfig: {url: 'cfOrgConfig/query', method: 'post', prefix: 'pro'}, // 查询机构参数配置
  insertCfOrgConfig: {url: 'cfOrgConfig/insert', prefix: 'pro'}, // 插入机构参数配置
  deleteCfOrgConfig: {url: 'cfOrgConfig/delete', prefix: 'pro'}, // 删除机构参数配置
  updateCfOrgConfig: {url: 'cfOrgConfig/update', prefix: 'pro'}, // 更新机构参数配置

  //三方机构配置
  queryCfThirdOrg: {url: 'cfThirdOrg/query', method: 'post', prefix: 'pro'}, // 查询机构参数配置
  insertCfThirdOrg: {url: 'cfThirdOrg/insert', prefix: 'pro'}, // 插入机构参数配置
  deleteCfThirdOrg: {url: 'cfThirdOrg/delete', prefix: 'pro'}, // 删除机构参数配置
  updateCfThirdOrg: {url: 'cfThirdOrg/update', prefix: 'pro'}, // 更新机构参数配置

  //地域管理
  queryRegionManage: {url: 'region/select', method: 'post', prefix: 'pro'}, // 查询机构参数配置
  insertRegionManage: {url: 'region/insert', prefix: 'pro'}, // 插入机构参数配置
  deleteRegionManage: {url: 'region/delete', prefix: 'pro'}, // 删除机构参数配置
  updateRegionManage: {url: 'region/update', prefix: 'pro'}, // 更新机构参数配置
  //地域管理
  querySysRegion: {url: 'district/querySysRegion', method: 'post', prefix: 'pro'},

  querySysRegionDetails: { url: 'district/querySysRegionDetails', method: 'post', prefix: 'pro' },

  createSysRegion: {url: 'district/createSysRegion', method: 'post', prefix: 'pro'},
  //天地图
  getMapGeocoder: {url: 'geocoder', prefix: 'api',method:'get'}, // 更新机构参数配置
}
// export const apiDatatext={
//   //图片上传
//   imageUpdata:'image/manager/upload',
// }

// 测试环境接口地址
export const prefixUrl = {
  // 默认加上 /pro 前缀
  pro:
    process.env.NODE_ENV === 'development'
      ? '/pro/admin'
      : '/pro/admin',
  pro1:
    process.env.NODE_ENV === 'development'
      ? '/pro1'
      : '/pro',
  // 不加前缀
  noPrefix:
    process.env.NODE_ENV === 'development'
      ? ''
      : '',
  // 基础服务
  baseService:
    process.env.NODE_ENV === 'development'
      ? '/baseService'
      : '/pro/common/common',
  protos:
    process.env.NODE_ENV === 'development'
      ? '/pr2tos'
      : '/pro/tos',
  ssmidm:
    process.env.NODE_ENV === 'development'
      ? '/ssmidm'
      : '/pro/idm',
  downLoadUrlPrefix: process.env.NODE_ENV === 'development'
    ? '	/pro' + '/image/manager/download?imageSrc='
    : '/pro' + '/image/manager/download?imageSrc=',
  pro11: process.env.NODE_ENV === 'development'
    ? '/pro/11admin'
    : '/pro',
  api: process.env.NODE_ENV === 'development'
    ? 'http://api.tianditu.gov.cn'
    : 'http://api.tianditu.gov.cn',
}



// WEBPACK FOOTER //
// ./src/api/config.js